export default "__VITE_ASSET__B7k_WZCv__"